import type {PropertyNameOrgConflicts} from '@github-ui/custom-properties-types'
import {FormControl, Link, TextInput} from '@primer/react'
import {clsx} from 'clsx'
import {type ComponentProps, useState} from 'react'

import {OrgConflictsDialog} from '../OrgConflictsDialog'
import styles from './PropertyDefinitionForm.module.css'

interface Props {
  value: string
  validationError?: string
  orgConflicts?: PropertyNameOrgConflicts
  readonly: boolean
  onChange: (value: string) => void
  inputRef?: ComponentProps<typeof TextInput>['ref']
  className?: string
}

export function DefinitionNameField({
  value,
  orgConflicts,
  validationError,
  readonly,
  onChange,
  inputRef,
  className,
}: Props) {
  const [showOrgConflicts, setShowOrgConflicts] = useState(false)

  const propertyNameValidationId = 'property-name-validation-error'

  return (
    <>
      <FormControl required disabled={readonly} className={clsx(styles.propertyFormControl, className)}>
        <FormControl.Label>Name</FormControl.Label>
        <TextInput
          block
          ref={inputRef}
          aria-describedby={validationError ? propertyNameValidationId : undefined}
          aria-invalid={!!validationError}
          value={value}
          onChange={e => onChange(e.target.value)}
        />

        {validationError && (
          <>
            <FormControl.Validation variant="error" id={propertyNameValidationId}>
              {validationError}
            </FormControl.Validation>
            {orgConflicts?.usages.length ? (
              <>
                <FormControl.Caption>
                  See{' '}
                  <Link
                    inline
                    href="#"
                    onClick={e => {
                      e.preventDefault()
                      setShowOrgConflicts(true)
                    }}
                  >
                    organizations
                  </Link>{' '}
                  with this property
                </FormControl.Caption>
              </>
            ) : null}
          </>
        )}
      </FormControl>

      {showOrgConflicts && orgConflicts && (
        <OrgConflictsDialog
          title="Conflicts"
          displayMessage="This property cannot be created because there are conflicting properties in this enterprise's organizations"
          onClose={() => setShowOrgConflicts(false)}
          orgConflicts={orgConflicts}
        />
      )}
    </>
  )
}

try{ DefinitionNameField.displayName ||= 'DefinitionNameField' } catch {}